import { IAnimation } from 'src/interfaces';
import { lang } from 'src/utils';

export const ANIMATIONS_DATA: {
  id: string;
  label: string;
  key: keyof IAnimation;
}[] = [
  {
    id: 'animation2',
    label: lang.productAnimation.productName,
    key: 'productName',
  },
  {
    id: 'animation3',
    label: lang.productAnimation.priceLabelStyling,
    key: 'label',
  },
  {
    id: 'animation4',
    label: lang.productAnimation.price,
    key: 'price',
  },
  {
    id: 'animation5',
    label: lang.productAnimation.nutrition,
    key: 'nutrition',
  },
  {
    id: 'animation6',
    label: lang.productDisclaimer,
    key: 'disclaimer',
  },
];
